/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdminTenantSettingKey } from './adminTenantSettingKey';


export interface AdminTenantSettingApiModel { 
    key: AdminTenantSettingKey;
    value: string;
}
export namespace AdminTenantSettingApiModel {
}


